/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QuoteRecomputeExpressionDependencyGraphMutationVariables = Types.Exact<{
  input: Types.DocumentRecomputePropertiesAndExpressionsInput;
}>;


export type QuoteRecomputeExpressionDependencyGraphMutation = { documentRecomputePropertiesAndExpressions: { __typename: 'DocumentRecomputePropertiesAndExpressionsResult' } };


export const QuoteRecomputeExpressionDependencyGraphDocument = gql`
    mutation QuoteRecomputeExpressionDependencyGraph($input: DocumentRecomputePropertiesAndExpressionsInput!) {
  documentRecomputePropertiesAndExpressions(input: $input) {
    __typename
  }
}
    `;
export type QuoteRecomputeExpressionDependencyGraphMutationFn = Apollo.MutationFunction<QuoteRecomputeExpressionDependencyGraphMutation, QuoteRecomputeExpressionDependencyGraphMutationVariables>;

/**
 * __useQuoteRecomputeExpressionDependencyGraphMutation__
 *
 * To run a mutation, you first call `useQuoteRecomputeExpressionDependencyGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteRecomputeExpressionDependencyGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteRecomputeExpressionDependencyGraphMutation, { data, loading, error }] = useQuoteRecomputeExpressionDependencyGraphMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuoteRecomputeExpressionDependencyGraphMutation(baseOptions?: Apollo.MutationHookOptions<QuoteRecomputeExpressionDependencyGraphMutation, QuoteRecomputeExpressionDependencyGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuoteRecomputeExpressionDependencyGraphMutation, QuoteRecomputeExpressionDependencyGraphMutationVariables>(QuoteRecomputeExpressionDependencyGraphDocument, options);
      }
export type QuoteRecomputeExpressionDependencyGraphMutationHookResult = ReturnType<typeof useQuoteRecomputeExpressionDependencyGraphMutation>;
export type QuoteRecomputeExpressionDependencyGraphMutationResult = Apollo.MutationResult<QuoteRecomputeExpressionDependencyGraphMutation>;
export type QuoteRecomputeExpressionDependencyGraphMutationOptions = Apollo.BaseMutationOptions<QuoteRecomputeExpressionDependencyGraphMutation, QuoteRecomputeExpressionDependencyGraphMutationVariables>;